import React from 'react';
import Head from '@components/atoms/head/head';
import { useTranslation } from 'next-i18next';
import { defaultMetas } from '@constants/metas/default';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { GetServerSideProps, NextPageWithLayout } from 'next';
import extractFromContext from '@helpers/utils/extract-from-context';
import { usePreferences } from '@context/preferences.context';
import PageAuthenticationGuard from '@components/atoms/authentication/page-authentication-guard/page-authentication-guard';
import { useBucket } from '@context/bucket.context';
import RecommendationsWrapper from '@components/personalized/recommendations-wrapper/recommendations-wrapper';
import { LDState } from '@components/bucketTest/types';
import logger from '@helpers/utils/logger/client';
import DefaultLayout from '@layouts/default-layout';
import { getAppInitialProps } from '@helpers/initial-props';

const RecommendationsPage: NextPageWithLayout = () => {
  const { t } = useTranslation();
  const { language } = usePreferences();
  const { isFeatureEnabled, state } = useBucket();

  const pageMetas = defaultMetas[language];
  const ldLoading = state === LDState.INITIALIZING || state === LDState.PENDING;
  const enableMyRecommendations = isFeatureEnabled((f) => !!f.enableMyRecommendations, true);

  if (typeof window !== 'undefined' && !ldLoading && !enableMyRecommendations) {
    logger.error(`recommendations::FF-OFF::enableMyRecommendations`);
    window.location.href = t('LINKS.NEW_IN');
    return <></>;
  }

  return (
    <PageAuthenticationGuard
      modalType="login"
      redirectionUrl={t('LINKS.NEW_IN')}
    >
      <Head metadata={pageMetas} />
      <RecommendationsWrapper />
    </PageAuthenticationGuard>
  );
};

RecommendationsPage.Layout = [DefaultLayout];
RecommendationsPage.PageType = 'RecommendationsPage';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale } = extractFromContext(context);
  const initialProps = await getAppInitialProps(context);
  const translations = await serverSideTranslations(locale, ['default-layout', 'vc-authentication', 'a11y', 'common']);

  return {
    props: {
      ...initialProps,
      ...translations,
    },
  };
};

export default RecommendationsPage;
